// extracted by mini-css-extract-plugin
export default {"socketAdminSendMsgForm":"SocketAdmin_socketAdminSendMsgForm__voSst","socketAdminInput":"SocketAdmin_socketAdminInput__tjk4q","socketAdminBtn":"SocketAdmin_socketAdminBtn__cSqef"};